import React from "react";
import { Chip } from "@mui/material";
import StorageIcon from "@mui/icons-material/Storage";
import ShieldIcon from "@mui/icons-material/Shield";
import GroupIcon from "@mui/icons-material/Group";
import { DomainType } from "../../utils/enums";

const DomainChip = ({ domainKey, domainTitle }) => {
  // Define color themes and icons based on domain key
  const getDomainProperties = (key) => {
    switch (key) {
      case DomainType.INFRA:
        return {
          backgroundColor: "#E5F7FF",
          textColor: "#0277BD",
          icon: <StorageIcon fontSize="small" />,
        };
      case DomainType.RISK:
        return {
          backgroundColor: "#FFF7E0",
          textColor: "#B7791F",
          icon: <ShieldIcon fontSize="small" />,
        };
      case DomainType.PEOPLE:
        return {
          backgroundColor: "#E8FBF3",
          textColor: "#057F28",
          icon: <GroupIcon fontSize="small" />,
        };
      default:
        return {
          backgroundColor: "#F3F4F6",
          textColor: "#6B7280",
          icon: null,
        };
    }
  };

  const { backgroundColor, textColor, icon } = getDomainProperties(domainKey);

  return (
    <Chip
      icon={icon}
      label={domainTitle}
      sx={{
        height: "24px",
        backgroundColor: backgroundColor,
        color: textColor,
        fontWeight: 600,
        fontSize: "11px",
        border: "none",
        borderRadius: "6px",
        letterSpacing: "0.3px",
        textTransform: "uppercase",
        boxShadow: `0 1px 3px ${textColor}10`,
        transition: "all 0.2s ease",
        "& .MuiChip-icon": {
          color: textColor,
          marginLeft: "6px",
          marginRight: "6px",
          fontSize: "14px",
        },
        "& .MuiChip-label": {
          padding: "0 8px 0 0",
        },
        "&:hover": {
          boxShadow: `0 2px 4px ${textColor}20`,
        },
      }}
    />
  );
};

export default DomainChip;
